webpackJsonp([142966368958528],{

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/christmas_bible_read.c0023150.jpg";

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/christmas_candle_blow_1937.7c3fc5e2.jpg";

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/christmas_candle_blow_1963_2.2902b571.jpg";

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/christmas_childplay_19...4.686bb325.jpg";

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/christmas_childplay_1963.cd404bb3.jpg";

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/christmas_family_tree.929efae8.jpg";

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic_filmstill_koester_detmold1937_02.6cb0b21f.jpg";

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic_filmstill_koester_detmold1937_04.8dd2eadd.jpg";

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactImageGallery = __webpack_require__(27);
	
	var _reactImageGallery2 = _interopRequireDefault(_reactImageGallery);
	
	__webpack_require__(25);
	
	var _christmas_candle_blow_ = __webpack_require__(502);
	
	var _christmas_candle_blow_2 = _interopRequireDefault(_christmas_candle_blow_);
	
	var _christmas_candle_blow_1963_ = __webpack_require__(503);
	
	var _christmas_candle_blow_1963_2 = _interopRequireDefault(_christmas_candle_blow_1963_);
	
	var _christmas_bible_read = __webpack_require__(501);
	
	var _christmas_bible_read2 = _interopRequireDefault(_christmas_bible_read);
	
	var _christmas_childplay_ = __webpack_require__(505);
	
	var _christmas_childplay_2 = _interopRequireDefault(_christmas_childplay_);
	
	var _christmas_childplay_3 = __webpack_require__(504);
	
	var _christmas_childplay_4 = _interopRequireDefault(_christmas_childplay_3);
	
	var _christmas_family_tree = __webpack_require__(506);
	
	var _christmas_family_tree2 = _interopRequireDefault(_christmas_family_tree);
	
	var _pic_filmstill_koester_detmold1937_ = __webpack_require__(507);
	
	var _pic_filmstill_koester_detmold1937_2 = _interopRequireDefault(_pic_filmstill_koester_detmold1937_);
	
	var _pic_filmstill_koester_detmold1937_3 = __webpack_require__(508);
	
	var _pic_filmstill_koester_detmold1937_4 = _interopRequireDefault(_pic_filmstill_koester_detmold1937_3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SunSmartPage = function SunSmartPage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-5 project-info' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Family Movies : Movie Families'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-content' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Since the popularisation of the cine camera in the 1930s a lot of families tend to record similar events: Christmas, birthdays, children\u2019s play and daily life activities. Private family movies of the 20th century are an important everyday historical source: e.g. how has the perception on life for families changed? How has the way of filming children changed? At the same time family movies are evidence of how families acquire media technology in every day\u2019s life: e.g. how have families handled the cine/ video camera and who was filming the scenery?'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'The research focused on the analysis of home movies from the 1950s until today to find out about changes and continuities of family lives, in particular the ideals of family and their social practices around Christmas.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'On the occasion of the International Home Movie Day 2012, the research results and selected film clips were displayed at a public event conducted by the Folklore Studies/ Cultural Anthropology Seminar, University of Muenster and the LWL-Media Center Westphalia. Numerous visitors took up the offer of a guided tour through the movie archive and several home movies were screened on 8mm- and Super 8-movie projectors.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'A further analysis of the material will be provided upon request.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-7' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'slider' },
	                    _react2.default.createElement(_reactImageGallery2.default, {
	                        showThumbnails: false,
	                        showFullscreenButton: false,
	                        autoPlay: true,
	                        items: [{ original: _christmas_candle_blow_2.default }, { original: _christmas_candle_blow_1963_2.default }, { original: _christmas_bible_read2.default }, { original: _christmas_childplay_2.default }, { original: _christmas_childplay_4.default }, { original: _christmas_family_tree2.default }, { original: _pic_filmstill_koester_detmold1937_2.default }, { original: _pic_filmstill_koester_detmold1937_4.default }] })
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'project-blurb' },
	                    'A cultural anthropological research about family ideals and social practices around Christmas in home movies.'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'tags' },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Home Movies'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'International Home Movie Day'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Family and Kinship Studies'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Media Technology Studies'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Childhood Concept'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Christmas'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'footer-info' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Cooperation Partner:'
	                        ),
	                        ' WWU University M\xFCnster, LWL-Media Center Westphalia, CHM Center of Home Movies'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Source:'
	                        ),
	                        ' LWL-Media Center Westphalia Archive with over 1.200 film documents'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Date:'
	                        ),
	                        ' April 2012 - March 2013'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = SunSmartPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-familymovies-moviefamilies-js-8045e8205bd0b51c09b4.js